




import { defineComponent, onMounted, ref } from "@vue/composition-api";
import { loginToken } from "@/lib/loginHelpers";
import BasePage from "@/components/BasePage";

export default defineComponent({
  name: "PageLoginToken",
  components: { BasePage },
  props: {
    token: { type: String, required: true },
  },
  setup(props, { root }) {
    const loading = ref(false);

    onMounted(async () => {
      try {
        loading.value = true;
        await loginToken(props.token);
        root.$router.push({ name: "home" }).then(() => location.reload());
      } finally {
        loading.value = false;
      }
    });

    return { loading };
  },
});
